import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c03eefe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "base"
}
const _hoisted_2 = {
  key: 1,
  class: "app-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Establisting connection to the server...", -1))
const _hoisted_4 = [
  _hoisted_3
]

import TheBaseNavigation from '../components/TheBaseNavigation.vue';
import { useLoadingStore } from '@/stores/LoadingStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseView',
  setup(__props) {

const loadingStore = useLoadingStore();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(loadingStore).appLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TheBaseNavigation),
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
}
}

})